import { useCallback } from 'react'

import type { UseMembersSettingsReturn } from './use-members-settings.hook'

interface UseConfirmHandlersProps {
  memberToRemoveId: string | null
  invitationToRevokeId: string | null
  setMemberToRemoveId: (id: string | null) => void
  setInvitationToRevokeId: (id: string | null) => void
  setIsLeaveDialogOpen: (isOpen: boolean) => void
}

export const useMemberConfirmHandlers = ({
  memberToRemoveId,
  invitationToRevokeId,
  setMemberToRemoveId,
  setInvitationToRevokeId,
  setIsLeaveDialogOpen,
}: UseConfirmHandlersProps) => {
  const handleRemoveConfirm = useCallback(
    (settings: UseMembersSettingsReturn) => async (): Promise<void> => {
      if (!memberToRemoveId) return
      await settings.handleRemoveMember(memberToRemoveId)
      setMemberToRemoveId(null)
    },
    [memberToRemoveId, setMemberToRemoveId]
  )

  const handleRevokeConfirm = useCallback(
    (settings: UseMembersSettingsReturn) => async (): Promise<void> => {
      if (!invitationToRevokeId) return
      await settings.handleRevokeInvitation(invitationToRevokeId)
      setInvitationToRevokeId(null)
    },
    [invitationToRevokeId, setInvitationToRevokeId]
  )

  const handleLeaveConfirm = useCallback(
    (settings: UseMembersSettingsReturn) => async (): Promise<void> => {
      await settings.handleLeaveOrganization()
      setIsLeaveDialogOpen(false)
    },
    [setIsLeaveDialogOpen]
  )

  return { handleRemoveConfirm, handleRevokeConfirm, handleLeaveConfirm }
}
